import { Children, cloneElement, useEffect } from 'react'
import { TabProvider, useTabContext } from './TabContext'

// Composant de Menu des Tabs
export const TabMenu = ({ 
  tabs = [], 
  className = '', 
  activeClassName = 'tab-active',
  onTabChange 
}) => {
  const { activeTab, setActiveTab } = useTabContext()

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
    onTabChange && onTabChange(tabId)
  }

  return (
    <div className={`tabs tabs-border ${className}`}>
      {tabs.map((tab) => (
        <a
          key={tab.id}
          className={`tab ${activeTab === tab.id ? activeClassName : ''}`}
          onClick={() => handleTabChange(tab.id)}
        >
          {tab.label}
        </a>
      ))}
    </div>
  )
}

// Composant de Contenu des Tabs
export const TabContent = ({ 
  tabs = [], 
  className = '',
  renderTab 
}) => {
  const { activeTab } = useTabContext()

  // Fonction pour ajuster le défilement lors du clic sur un lien d'ancrage
  const handleAnchorClick = (e) => {
    if (e.target.tagName === 'A' && e.target.getAttribute('href')?.startsWith('#')) {
      e.preventDefault()
      const targetId = e.target.getAttribute('href').slice(1)
      const targetElement = document.getElementById(targetId)
      
      if (targetElement) {
        // Récupérer le conteneur de défilement
        const scrollContainer = document.querySelector('.tab-content-container')
        
        // Calculer la position de défilement en tenant compte de l'en-tête fixe
        const headerOffset = 320;
        const elementPosition = targetElement.getBoundingClientRect().top
        const offsetPosition = elementPosition + scrollContainer.scrollTop - headerOffset
        
        // Faire défiler jusqu'à l'élément avec un décalage
        scrollContainer.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
        document.querySelectorAll('.menu a').forEach( i => i.classList.remove('menu-active'))
        e.target.classList.add('menu-active')
      }
    }
  }

  useEffect(() => { 
    // Ajouter l'écouteur d'événements
    const menuElement = document.querySelector('.menu')
    if (menuElement) {
      menuElement.addEventListener('click', handleAnchorClick)
    }
    
    // Nettoyer l'écouteur d'événements
    return () => {
      if (menuElement) {
        menuElement.removeEventListener('click', handleAnchorClick)
      }
    }
  }, [])

  return (
    <div className={`tab-content-container ${className}`}>
      {tabs.map((tab) => (
        activeTab === tab.id && (
          <div key={tab.id}>
            {renderTab ? renderTab(tab) : tab.content}
          </div>
        )
      ))}
    </div>
  )
}

// Composant Principal de Gestion des Tabs
export const TabManager = ({ 
  tabs, 
  initialTab = null, 
  children,
  onTabChange,
  renderTab,
  className = '',
  contentClassName = '',
  menuClassName = ''
}) => {
  // Résoudre le tab initial (premier tab si non spécifié)
  const resolvedInitialTab = initialTab || tabs[0]?.id

  return (
    <TabProvider initialTab={resolvedInitialTab}>
      <div className={`tab-manager ${className}`}>
        {Children.map(children, child => 
          cloneElement(child, { 
            tabs, 
            onTabChange,
            renderTab,
            className: child.type === TabMenu ? menuClassName : contentClassName
          })
        )}
      </div>
    </TabProvider>
  )
}

export default TabManager